import Model from './vouchers.model'

let storeContent = utils.generateStore({
   Model,
   vouchers: [],
   selected_vouchers: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async filterVouchers(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpointSecure({
                  resource: 'commons',
                  action: 'list',
                  data: {
                     rules: {
                        match: {
                           created_at: {
                              $gte: dayjs(`${data.date[0]} 00:00:00`,'DD-MM-YYYY HH:mm:SS').toISOString(),
                              $lte: dayjs(`${data.date[1]} 23:59:59`,'DD-MM-YYYY HH:mm:SS').toISOString(),
                           }
                        }
                     }
                  },
                  meta_data: {
                     service: "rewards",
                     collection: "voucher",
                  }
               })
               ctx.commit('vouchers', res.result.records);
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         if (payload.action === 'vouchers:view_cards') {
            ctx.getters.router.push({name: 'Vouchers-View', params: {id: payload.rows[0]._id}})
         }
      },
      async fetchVouchers(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {

                     }
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "voucher",
               }
            })
            ctx.commit('vouchers', res.result.records);
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            // await ctx.dispatch('fetchVouchers')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};